/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.ts to modify the generation of this file.


import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-nextjs';

import { BYOCWrapper, FEaaSWrapper } from '@sitecore-jss/sitecore-jss-nextjs';

import * as CdpPageView from 'src/components/CdpPageView';
import * as ContentBlockTest from 'src/components/ContentBlockTest';
import * as FEAASScripts from 'src/components/FEAASScripts';
import * as ActionLink from 'src/components/atoms/ActionLink';
import * as Button from 'src/components/atoms/Button';
import * as Chip from 'src/components/atoms/Chip';
import * as CustomButton from 'src/components/atoms/CustomButton';
import * as CustomInput from 'src/components/atoms/CustomInput';
import * as CustomSelector from 'src/components/atoms/CustomSelector';
import * as CustomTextArea from 'src/components/atoms/CustomTextArea';
import * as GlobalSearchbar from 'src/components/atoms/GlobalSearchbar';
import * as HeroParagraph from 'src/components/atoms/HeroParagraph';
import * as IconText from 'src/components/atoms/IconText';
import * as Icons from 'src/components/atoms/Icons';
import * as Image from 'src/components/atoms/Image';
import * as ImageGrid from 'src/components/atoms/ImageGrid';
import * as PillList from 'src/components/atoms/PillList';
import * as TextBox from 'src/components/atoms/TextBox';
import * as Video from 'src/components/atoms/Video';
import * as ClinicalTrialsDetails from 'src/components/clinical-trials/ClinicalTrialsDetails';
import * as ClinicalTrialsFilters from 'src/components/clinical-trials/ClinicalTrialsFilters';
import * as ClinicalTrialsResult from 'src/components/clinical-trials/ClinicalTrialsResult';
import * as ClinicalTrialsSearch from 'src/components/clinical-trials/ClinicalTrialsSearch';
import * as ClinicalTrialsSearchBar from 'src/components/clinical-trials/ClinicalTrialsSearchBar';
import * as ClinicalTrialsSearchResults from 'src/components/clinical-trials/ClinicalTrialsSearchResults';
import * as ClinicalTrialsSelectedFilters from 'src/components/clinical-trials/ClinicalTrialsSelectedFilters';
import * as ClinicalTrialsSkeletons from 'src/components/clinical-trials/ClinicalTrialsSkeletons';
import * as ClinicalTrialsSortBy from 'src/components/clinical-trials/ClinicalTrialsSortBy';
import * as index from 'src/components/clinical-trials/index';
import * as HeroCampaign from 'src/components/common/HeroCampaign';
import * as HeroComponent from 'src/components/common/HeroComponent';
import * as FilterContext from 'src/components/context/FilterContext';
import * as FormContext from 'src/components/context/FormContext';
import * as ThemeContext from 'src/components/context/ThemeContext';
import * as CareActions from 'src/components/getcarenow/CareActions';
import * as CareScheduleAndChat from 'src/components/getcarenow/CareScheduleAndChat';
import * as DisclaimerWidget from 'src/components/getcarenow/DisclaimerWidget';
import * as GetCareFooter from 'src/components/getcarenow/GetCareFooter';
import * as PageTitle from 'src/components/getcarenow/PageTitle';
import * as BackgroundImage from 'src/components/gic/BackgroundImage';
import * as ContentBlock from 'src/components/gic/ContentBlock';
import * as GICFooter from 'src/components/gic/GICFooter';
import * as GICHeader from 'src/components/gic/GICHeader';
import * as GICLayout from 'src/components/gic/GICLayout';
import * as GICPageGrid from 'src/components/gic/GICPageGrid';
import * as MammogramCard from 'src/components/gic/MammogramCard';
import * as OverviewArrow from 'src/components/gic/OverviewArrow';
import * as PageNavigation from 'src/components/gic/PageNavigation';
import * as YoutubeVideo from 'src/components/gic/YoutubeVideo';
import * as ActionButtonGroup from 'src/components/molecules/ActionButtonGroup';
import * as AdditionalCards from 'src/components/molecules/AdditionalCards';
import * as AlertListingFilters from 'src/components/molecules/AlertListingFilters';
import * as AlertListingGroup from 'src/components/molecules/AlertListingGroup';
import * as AlertProvider from 'src/components/molecules/AlertProvider';
import * as BreadcrumbPrintShare from 'src/components/molecules/BreadcrumbPrintShare';
import * as ButtonModal from 'src/components/molecules/ButtonModal';
import * as CardCarouselParent from 'src/components/molecules/CardCarouselParent';
import * as ContentSeparator from 'src/components/molecules/ContentSeparator';
import * as CriticalMessage from 'src/components/molecules/CriticalMessage';
import * as EventListItem from 'src/components/molecules/EventListItem';
import * as FeaturedLocations from 'src/components/molecules/FeaturedLocations';
import * as FeaturedProviders from 'src/components/molecules/FeaturedProviders';
import * as HospitalLocation from 'src/components/molecules/HospitalLocation';
import * as ImageSelection from 'src/components/molecules/ImageSelection';
import * as InfoMessage from 'src/components/molecules/InfoMessage';
import * as InfoTip from 'src/components/molecules/InfoTip';
import * as IntroParagraph from 'src/components/molecules/IntroParagraph';
import * as IntroSection from 'src/components/molecules/IntroSection';
import * as PaginationControls from 'src/components/molecules/PaginationControls';
import * as PersonResult from 'src/components/molecules/PersonResult';
import * as PhotoFeature from 'src/components/molecules/PhotoFeature';
import * as PrimarySubNav from 'src/components/molecules/PrimarySubNav';
import * as QuoteChild from 'src/components/molecules/QuoteChild';
import * as RecipeVideo from 'src/components/molecules/RecipeVideo';
import * as Shapes from 'src/components/molecules/Shapes';
import * as SplitContentCallout from 'src/components/molecules/SplitContentCallout';
import * as SpotLightCarouselParent from 'src/components/molecules/SpotLightCarouselParent';
import * as SpotlightGradient from 'src/components/molecules/SpotlightGradient';
import * as SpotlightLocations from 'src/components/molecules/SpotlightLocations';
import * as SpotlightNarrow from 'src/components/molecules/SpotlightNarrow';
import * as SpotlightTall from 'src/components/molecules/SpotlightTall';
import * as StickyCTA from 'src/components/molecules/StickyCTA';
import * as SubNavProvider from 'src/components/molecules/SubNavProvider';
import * as SystemAlertBanner from 'src/components/molecules/SystemAlertBanner';
import * as Toast from 'src/components/molecules/Toast';
import * as VideoPlayer from 'src/components/molecules/VideoPlayer';
import * as Accordion from 'src/components/organisms/Accordion';
import * as AllServices from 'src/components/organisms/AllServices';
import * as ArticleListingFilters from 'src/components/organisms/ArticleListingFilters';
import * as ArticleSummary from 'src/components/organisms/ArticleSummary';
import * as BlogPostDetails from 'src/components/organisms/BlogPostDetails';
import * as BlogSubscribe from 'src/components/organisms/BlogSubscribe';
import * as CTASection from 'src/components/organisms/CTASection';
import * as CancerForms from 'src/components/organisms/CancerForms';
import * as CategoryPanel from 'src/components/organisms/CategoryPanel';
import * as ContactCard from 'src/components/organisms/ContactCard';
import * as ContactCardNew from 'src/components/organisms/ContactCardNew';
import * as ContentExpanderParent from 'src/components/organisms/ContentExpanderParent';
import * as CopyrightFooter from 'src/components/organisms/CopyrightFooter';
import * as DynamicLocationContent from 'src/components/organisms/DynamicLocationContent';
import * as DynamicProviderContent from 'src/components/organisms/DynamicProviderContent';
import * as EventListing from 'src/components/organisms/EventListing';
import * as EventListingVariations from 'src/components/organisms/EventListingVariations';
import * as FacultyStaffSearch from 'src/components/organisms/FacultyStaffSearch';
import * as GetCareHeader from 'src/components/organisms/GetCareHeader';
import * as HeaderModal from 'src/components/organisms/HeaderModal';
import * as LPFooter from 'src/components/organisms/LPFooter';
import * as LPNavigation from 'src/components/organisms/LPNavigation';
import * as LinkGroup from 'src/components/organisms/LinkGroup';
import * as LinkList from 'src/components/organisms/LinkList';
import * as LocationCallout from 'src/components/organisms/LocationCallout';
import * as MapImage from 'src/components/organisms/MapImage';
import * as MediaCarousel from 'src/components/organisms/MediaCarousel';
import * as MediaViewer from 'src/components/organisms/MediaViewer';
import * as OSFHeader from 'src/components/organisms/OSFHeader';
import * as OSFNavMobile from 'src/components/organisms/OSFNavMobile';
import * as OSFNavSubLinks from 'src/components/organisms/OSFNavSubLinks';
import * as PLDForm from 'src/components/organisms/PLDForm';
import * as PromptedActionsParent from 'src/components/organisms/PromptedActionsParent';
import * as QuoteParent from 'src/components/organisms/QuoteParent';
import * as R2Footer from 'src/components/organisms/R2Footer';
import * as R2Header from 'src/components/organisms/R2Header';
import * as R2SearchBar from 'src/components/organisms/R2SearchBar';
import * as RelatedBlogs from 'src/components/organisms/RelatedBlogs';
import * as RelatedEvents from 'src/components/organisms/RelatedEvents';
import * as RelatedNews from 'src/components/organisms/RelatedNews';
import * as RelatedPressRelease from 'src/components/organisms/RelatedPressRelease';
import * as RelatedRecipes from 'src/components/organisms/RelatedRecipes';
import * as RequestAppt from 'src/components/organisms/RequestAppt';
import * as SearchModal from 'src/components/organisms/SearchModal';
import * as SisterDetails from 'src/components/organisms/SisterDetails';
import * as SistersFooter from 'src/components/organisms/SistersFooter';
import * as TimelineChild from 'src/components/organisms/TimelineChild';
import * as TimelineParent from 'src/components/organisms/TimelineParent';
import * as VideoFeatureCard from 'src/components/organisms/VideoFeatureCard';
import * as eCard from 'src/components/organisms/eCard';
import * as LocationActionWidget from 'src/components/pld/locations/LocationActionWidget';
import * as LocationApptQuestions from 'src/components/pld/locations/LocationApptQuestions';
import * as LocationBio from 'src/components/pld/locations/LocationBio';
import * as LocationHero from 'src/components/pld/locations/LocationHero';
import * as LocationHours from 'src/components/pld/locations/LocationHours';
import * as LocationMap from 'src/components/pld/locations/LocationMap';
import * as LocationProfile from 'src/components/pld/locations/LocationProfile';
import * as LocationProvider from 'src/components/pld/locations/LocationProvider';
import * as LocationProviders from 'src/components/pld/locations/LocationProviders';
import * as LocationResult from 'src/components/pld/locations/LocationResult';
import * as LocationSearch from 'src/components/pld/locations/LocationSearch';
import * as LocationWidget from 'src/components/pld/locations/LocationWidget';
import * as LocationsSearchResults from 'src/components/pld/locations/LocationsSearchResults';
import * as LocationFilters from 'src/components/pld/locations/filters/LocationFilters';
import * as LMap from 'src/components/pld/locations/maps/LMap';
import * as MarkersAndClusters from 'src/components/pld/locations/maps/MarkersAndClusters';
import * as ProviderBio from 'src/components/pld/providers/ProviderBio';
import * as ProviderHero from 'src/components/pld/providers/ProviderHero';
import * as ProviderInsurance from 'src/components/pld/providers/ProviderInsurance';
import * as ProviderLocation from 'src/components/pld/providers/ProviderLocation';
import * as ProviderLocations from 'src/components/pld/providers/ProviderLocations';
import * as ProviderNextAvailable from 'src/components/pld/providers/ProviderNextAvailable';
import * as ProviderProfile from 'src/components/pld/providers/ProviderProfile';
import * as ProviderResult from 'src/components/pld/providers/ProviderResult';
import * as ProviderReviews from 'src/components/pld/providers/ProviderReviews';
import * as ProviderSchedulingWidget from 'src/components/pld/providers/ProviderSchedulingWidget';
import * as ProviderSearch from 'src/components/pld/providers/ProviderSearch';
import * as ProvidersLocationsMap from 'src/components/pld/providers/ProvidersLocationsMap';
import * as ProvidersSearchResults from 'src/components/pld/providers/ProvidersSearchResults';
import * as SearchShare from 'src/components/pld/providers/SearchShare';
import * as AvailabilityFilter from 'src/components/pld/providers/filters/AvailabilityFilter';
import * as FilterAccordionBtn from 'src/components/pld/providers/filters/FilterAccordionBtn';
import * as PreferredProviderFilter from 'src/components/pld/providers/filters/PreferredProviderFilter';
import * as ProviderFilters from 'src/components/pld/providers/filters/ProviderFilters';
import * as Toggle from 'src/components/pld/providers/filters/Toggle';
import * as ActionBar from 'src/components/pld/shared/ActionBar';
import * as ControlToggles from 'src/components/pld/shared/ControlToggles';
import * as Insurance from 'src/components/pld/shared/Insurance';
import * as MyChartConfig from 'src/components/pld/shared/MyChartConfig';
import * as ProfileBreadcrumb from 'src/components/pld/shared/ProfileBreadcrumb';
import * as RatingStars from 'src/components/pld/shared/RatingStars';
import * as ResultsControls from 'src/components/pld/shared/ResultsControls';
import * as SearchPaginationControls from 'src/components/pld/shared/SearchPaginationControls';
import * as SelectedFiltersList from 'src/components/pld/shared/SelectedFiltersList';
import * as Sidebar from 'src/components/pld/shared/Sidebar';
import * as SliderTabs from 'src/components/pld/shared/SliderTabs';
import * as SortBy from 'src/components/pld/shared/SortBy';
import * as Tag from 'src/components/pld/shared/Tag';
import * as ViewAllPanel from 'src/components/pld/shared/ViewAllPanel';
import * as DistanceFilter from 'src/components/pld/shared/filters/DistanceFilter';
import * as FiltersSearchBar from 'src/components/pld/shared/filters/FiltersSearchBar';
import * as LocationFilter from 'src/components/pld/shared/filters/LocationFilter';
import * as SearchBar from 'src/components/pld/shared/filters/SearchBar';
import * as SearchFilter from 'src/components/pld/shared/filters/SearchFilter';
import * as SearchTypeahead from 'src/components/pld/shared/filters/SearchTypeahead';
import * as SpecialtyFilter from 'src/components/pld/shared/filters/SpecialtyFilter';
import * as StandardFilter from 'src/components/pld/shared/filters/StandardFilter';
import * as ActionButton from 'src/components/r2/ActionButton';
import * as ArticleListingComponent from 'src/components/r2/ArticleListingComponent';
import * as ArticleSummaryComponent from 'src/components/r2/ArticleSummaryComponent';
import * as Banner from 'src/components/r2/Banner';
import * as BlogAuthor from 'src/components/r2/BlogAuthor';
import * as BlogCategories from 'src/components/r2/BlogCategories';
import * as Breadcrumb from 'src/components/r2/Breadcrumb';
import * as ContentCarousel from 'src/components/r2/ContentCarousel';
import * as ContentCarouselCard from 'src/components/r2/ContentCarouselCard';
import * as ContentCarouselControls from 'src/components/r2/ContentCarouselControls';
import * as ContentListing from 'src/components/r2/ContentListing';
import * as CursorPagination from 'src/components/r2/CursorPagination';
import * as DynamicCTAParent from 'src/components/r2/DynamicCTAParent';
import * as ExpandableContentPromo from 'src/components/r2/ExpandableContentPromo';
import * as FiveUp from 'src/components/r2/FiveUp';
import * as FiveUpCard from 'src/components/r2/FiveUpCard';
import * as FiveUpControls from 'src/components/r2/FiveUpControls';
import * as Footer from 'src/components/r2/Footer';
import * as FooterLinkList from 'src/components/r2/FooterLinkList';
import * as FooterResources from 'src/components/r2/FooterResources';
import * as FooterResourcesList from 'src/components/r2/FooterResourcesList';
import * as FooterSocialBarIcons from 'src/components/r2/FooterSocialBarIcons';
import * as Form from 'src/components/r2/Form';
import * as GeneralContent from 'src/components/r2/GeneralContent';
import * as Header from 'src/components/r2/Header';
import * as ImageCallOut from 'src/components/r2/ImageCallOut';
import * as ImageORVideoContent from 'src/components/r2/ImageORVideoContent';
import * as LinkBar from 'src/components/r2/LinkBar';
import * as ListFilters from 'src/components/r2/ListFilters';
import * as ListingComponent from 'src/components/r2/ListingComponent';
import * as LogoWall from 'src/components/r2/LogoWall';
import * as Navigation from 'src/components/r2/Navigation';
import * as OneUp from 'src/components/r2/OneUp';
import * as Pagination from 'src/components/r2/Pagination';
import * as PullQuote from 'src/components/r2/PullQuote';
import * as RightRail from 'src/components/r2/RightRail';
import * as RightRailNavigation from 'src/components/r2/RightRailNavigation';
import * as Search from 'src/components/r2/Search';
import * as SearchData from 'src/components/r2/SearchData';
import * as SixUp from 'src/components/r2/SixUp';
import * as SocialMediaLinks from 'src/components/r2/SocialMediaLinks';
import * as SubScribe from 'src/components/r2/SubScribe';
import * as Swiper from 'src/components/r2/Swiper';
import * as TabGroup from 'src/components/r2/TabGroup';
import * as Table from 'src/components/r2/Table';
import * as TextCallOut from 'src/components/r2/TextCallOut';
import * as ThreeColumnLayout from 'src/components/r2/ThreeColumnLayout';
import * as ThreeUp from 'src/components/r2/ThreeUp';
import * as TwoColumn from 'src/components/r2/TwoColumn';
import * as GET_AUTHOR_ID from 'src/components/r2/graphql/GET_AUTHOR_ID';
import * as GET_BLOG_POSTS from 'src/components/r2/graphql/GET_BLOG_POSTS';
import * as GET_CATEGORIES from 'src/components/r2/graphql/GET_CATEGORIES';
import * as GET_CONTACT_CARDS from 'src/components/r2/graphql/GET_CONTACT_CARDS';
import * as GET_FACULTY_STAFF from 'src/components/r2/graphql/GET_FACULTY_STAFF';
import * as ContentCard from 'src/components/shared/ContentCard';
import * as PictureContentCard from 'src/components/shared/PictureContentCard';
import * as ScriptLoader from 'src/components/shared/ScriptLoader';
import * as SharedContentBlock from 'src/components/shared/SharedContentBlock';
import * as AlertTypes from 'src/components/types/AlertTypes';
import * as ClinicalFocusTypes from 'src/components/types/ClinicalFocusTypes';
import * as Department from 'src/components/types/Department';
import * as FacultyTypes from 'src/components/types/FacultyTypes';
import * as FilterTypes from 'src/components/types/FilterTypes';
import * as ListItem from 'src/components/types/ListItem';
import * as LocationFunctionTypes from 'src/components/types/LocationFunctionTypes';
import * as LocationTypes from 'src/components/types/LocationTypes';
import * as MapTypes from 'src/components/types/MapTypes';
import * as OSFHeaderTypes from 'src/components/types/OSFHeaderTypes';
import * as ProviderTypes from 'src/components/types/ProviderTypes';
import * as ScheduleTypes from 'src/components/types/ScheduleTypes';
import * as SpecialtyTypes from 'src/components/types/SpecialtyTypes';

export const components = new Map();
components.set('BYOCWrapper', BYOCWrapper);
components.set('FEaaSWrapper', FEaaSWrapper);

components.set('CdpPageView', CdpPageView);
components.set('ContentBlockTest', ContentBlockTest);
components.set('FEAASScripts', FEAASScripts);
components.set('ActionLink', ActionLink);
components.set('Button', Button);
components.set('Chip', Chip);
components.set('CustomButton', CustomButton);
components.set('CustomInput', CustomInput);
components.set('CustomSelector', CustomSelector);
components.set('CustomTextArea', CustomTextArea);
components.set('GlobalSearchbar', GlobalSearchbar);
components.set('HeroParagraph', HeroParagraph);
components.set('IconText', IconText);
components.set('Icons', Icons);
components.set('Image', Image);
components.set('ImageGrid', ImageGrid);
components.set('PillList', PillList);
components.set('TextBox', TextBox);
components.set('Video', Video);
components.set('ClinicalTrialsDetails', ClinicalTrialsDetails);
components.set('ClinicalTrialsFilters', ClinicalTrialsFilters);
components.set('ClinicalTrialsResult', ClinicalTrialsResult);
components.set('ClinicalTrialsSearch', ClinicalTrialsSearch);
components.set('ClinicalTrialsSearchBar', ClinicalTrialsSearchBar);
components.set('ClinicalTrialsSearchResults', ClinicalTrialsSearchResults);
components.set('ClinicalTrialsSelectedFilters', ClinicalTrialsSelectedFilters);
components.set('ClinicalTrialsSkeletons', ClinicalTrialsSkeletons);
components.set('ClinicalTrialsSortBy', ClinicalTrialsSortBy);
components.set('index', index);
components.set('HeroCampaign', HeroCampaign);
components.set('HeroComponent', HeroComponent);
components.set('FilterContext', FilterContext);
components.set('FormContext', FormContext);
components.set('ThemeContext', ThemeContext);
components.set('CareActions', CareActions);
components.set('CareScheduleAndChat', CareScheduleAndChat);
components.set('DisclaimerWidget', DisclaimerWidget);
components.set('GetCareFooter', GetCareFooter);
components.set('PageTitle', PageTitle);
components.set('BackgroundImage', BackgroundImage);
components.set('ContentBlock', ContentBlock);
components.set('GICFooter', GICFooter);
components.set('GICHeader', GICHeader);
components.set('GICLayout', GICLayout);
components.set('GICPageGrid', GICPageGrid);
components.set('MammogramCard', MammogramCard);
components.set('OverviewArrow', OverviewArrow);
components.set('PageNavigation', PageNavigation);
components.set('YoutubeVideo', YoutubeVideo);
components.set('ActionButtonGroup', ActionButtonGroup);
components.set('AdditionalCards', AdditionalCards);
components.set('AlertListingFilters', AlertListingFilters);
components.set('AlertListingGroup', AlertListingGroup);
components.set('AlertProvider', AlertProvider);
components.set('BreadcrumbPrintShare', BreadcrumbPrintShare);
components.set('ButtonModal', ButtonModal);
components.set('CardCarouselParent', CardCarouselParent);
components.set('ContentSeparator', ContentSeparator);
components.set('CriticalMessage', CriticalMessage);
components.set('EventListItem', EventListItem);
components.set('FeaturedLocations', FeaturedLocations);
components.set('FeaturedProviders', FeaturedProviders);
components.set('HospitalLocation', HospitalLocation);
components.set('ImageSelection', ImageSelection);
components.set('InfoMessage', InfoMessage);
components.set('InfoTip', InfoTip);
components.set('IntroParagraph', IntroParagraph);
components.set('IntroSection', IntroSection);
components.set('PaginationControls', PaginationControls);
components.set('PersonResult', PersonResult);
components.set('PhotoFeature', PhotoFeature);
components.set('PrimarySubNav', PrimarySubNav);
components.set('QuoteChild', QuoteChild);
components.set('RecipeVideo', RecipeVideo);
components.set('Shapes', Shapes);
components.set('SplitContentCallout', SplitContentCallout);
components.set('SpotLightCarouselParent', SpotLightCarouselParent);
components.set('SpotlightGradient', SpotlightGradient);
components.set('SpotlightLocations', SpotlightLocations);
components.set('SpotlightNarrow', SpotlightNarrow);
components.set('SpotlightTall', SpotlightTall);
components.set('StickyCTA', StickyCTA);
components.set('SubNavProvider', SubNavProvider);
components.set('SystemAlertBanner', SystemAlertBanner);
components.set('Toast', Toast);
components.set('VideoPlayer', VideoPlayer);
components.set('Accordion', Accordion);
components.set('AllServices', AllServices);
components.set('ArticleListingFilters', ArticleListingFilters);
components.set('ArticleSummary', ArticleSummary);
components.set('BlogPostDetails', BlogPostDetails);
components.set('BlogSubscribe', BlogSubscribe);
components.set('CTASection', CTASection);
components.set('CancerForms', CancerForms);
components.set('CategoryPanel', CategoryPanel);
components.set('ContactCard', ContactCard);
components.set('ContactCardNew', ContactCardNew);
components.set('ContentExpanderParent', ContentExpanderParent);
components.set('CopyrightFooter', CopyrightFooter);
components.set('DynamicLocationContent', DynamicLocationContent);
components.set('DynamicProviderContent', DynamicProviderContent);
components.set('EventListing', EventListing);
components.set('EventListingVariations', EventListingVariations);
components.set('FacultyStaffSearch', FacultyStaffSearch);
components.set('GetCareHeader', GetCareHeader);
components.set('HeaderModal', HeaderModal);
components.set('LPFooter', LPFooter);
components.set('LPNavigation', LPNavigation);
components.set('LinkGroup', LinkGroup);
components.set('LinkList', LinkList);
components.set('LocationCallout', LocationCallout);
components.set('MapImage', MapImage);
components.set('MediaCarousel', MediaCarousel);
components.set('MediaViewer', MediaViewer);
components.set('OSFHeader', OSFHeader);
components.set('OSFNavMobile', OSFNavMobile);
components.set('OSFNavSubLinks', OSFNavSubLinks);
components.set('PLDForm', PLDForm);
components.set('PromptedActionsParent', PromptedActionsParent);
components.set('QuoteParent', QuoteParent);
components.set('R2Footer', R2Footer);
components.set('R2Header', R2Header);
components.set('R2SearchBar', R2SearchBar);
components.set('RelatedBlogs', RelatedBlogs);
components.set('RelatedEvents', RelatedEvents);
components.set('RelatedNews', RelatedNews);
components.set('RelatedPressRelease', RelatedPressRelease);
components.set('RelatedRecipes', RelatedRecipes);
components.set('RequestAppt', RequestAppt);
components.set('SearchModal', SearchModal);
components.set('SisterDetails', SisterDetails);
components.set('SistersFooter', SistersFooter);
components.set('TimelineChild', TimelineChild);
components.set('TimelineParent', TimelineParent);
components.set('VideoFeatureCard', VideoFeatureCard);
components.set('eCard', eCard);
components.set('LocationActionWidget', LocationActionWidget);
components.set('LocationApptQuestions', LocationApptQuestions);
components.set('LocationBio', LocationBio);
components.set('LocationHero', LocationHero);
components.set('LocationHours', LocationHours);
components.set('LocationMap', LocationMap);
components.set('LocationProfile', LocationProfile);
components.set('LocationProvider', LocationProvider);
components.set('LocationProviders', LocationProviders);
components.set('LocationResult', LocationResult);
components.set('LocationSearch', LocationSearch);
components.set('LocationWidget', LocationWidget);
components.set('LocationsSearchResults', LocationsSearchResults);
components.set('LocationFilters', LocationFilters);
components.set('LMap', LMap);
components.set('MarkersAndClusters', MarkersAndClusters);
components.set('ProviderBio', ProviderBio);
components.set('ProviderHero', ProviderHero);
components.set('ProviderInsurance', ProviderInsurance);
components.set('ProviderLocation', ProviderLocation);
components.set('ProviderLocations', ProviderLocations);
components.set('ProviderNextAvailable', ProviderNextAvailable);
components.set('ProviderProfile', ProviderProfile);
components.set('ProviderResult', ProviderResult);
components.set('ProviderReviews', ProviderReviews);
components.set('ProviderSchedulingWidget', ProviderSchedulingWidget);
components.set('ProviderSearch', ProviderSearch);
components.set('ProvidersLocationsMap', ProvidersLocationsMap);
components.set('ProvidersSearchResults', ProvidersSearchResults);
components.set('SearchShare', SearchShare);
components.set('AvailabilityFilter', AvailabilityFilter);
components.set('FilterAccordionBtn', FilterAccordionBtn);
components.set('PreferredProviderFilter', PreferredProviderFilter);
components.set('ProviderFilters', ProviderFilters);
components.set('Toggle', Toggle);
components.set('ActionBar', ActionBar);
components.set('ControlToggles', ControlToggles);
components.set('Insurance', Insurance);
components.set('MyChartConfig', MyChartConfig);
components.set('ProfileBreadcrumb', ProfileBreadcrumb);
components.set('RatingStars', RatingStars);
components.set('ResultsControls', ResultsControls);
components.set('SearchPaginationControls', SearchPaginationControls);
components.set('SelectedFiltersList', SelectedFiltersList);
components.set('Sidebar', Sidebar);
components.set('SliderTabs', SliderTabs);
components.set('SortBy', SortBy);
components.set('Tag', Tag);
components.set('ViewAllPanel', ViewAllPanel);
components.set('DistanceFilter', DistanceFilter);
components.set('FiltersSearchBar', FiltersSearchBar);
components.set('LocationFilter', LocationFilter);
components.set('SearchBar', SearchBar);
components.set('SearchFilter', SearchFilter);
components.set('SearchTypeahead', SearchTypeahead);
components.set('SpecialtyFilter', SpecialtyFilter);
components.set('StandardFilter', StandardFilter);
components.set('ActionButton', ActionButton);
components.set('ArticleListingComponent', ArticleListingComponent);
components.set('ArticleSummaryComponent', ArticleSummaryComponent);
components.set('Banner', Banner);
components.set('BlogAuthor', BlogAuthor);
components.set('BlogCategories', BlogCategories);
components.set('Breadcrumb', Breadcrumb);
components.set('ContentCarousel', ContentCarousel);
components.set('ContentCarouselCard', ContentCarouselCard);
components.set('ContentCarouselControls', ContentCarouselControls);
components.set('ContentListing', ContentListing);
components.set('CursorPagination', CursorPagination);
components.set('DynamicCTAParent', DynamicCTAParent);
components.set('ExpandableContentPromo', ExpandableContentPromo);
components.set('FiveUp', FiveUp);
components.set('FiveUpCard', FiveUpCard);
components.set('FiveUpControls', FiveUpControls);
components.set('Footer', Footer);
components.set('FooterLinkList', FooterLinkList);
components.set('FooterResources', FooterResources);
components.set('FooterResourcesList', FooterResourcesList);
components.set('FooterSocialBarIcons', FooterSocialBarIcons);
components.set('Form', Form);
components.set('GeneralContent', GeneralContent);
components.set('Header', Header);
components.set('ImageCallOut', ImageCallOut);
components.set('ImageORVideoContent', ImageORVideoContent);
components.set('LinkBar', LinkBar);
components.set('ListFilters', ListFilters);
components.set('ListingComponent', ListingComponent);
components.set('LogoWall', LogoWall);
components.set('Navigation', Navigation);
components.set('OneUp', OneUp);
components.set('Pagination', Pagination);
components.set('PullQuote', PullQuote);
components.set('RightRail', RightRail);
components.set('RightRailNavigation', RightRailNavigation);
components.set('Search', Search);
components.set('SearchData', SearchData);
components.set('SixUp', SixUp);
components.set('SocialMediaLinks', SocialMediaLinks);
components.set('SubScribe', SubScribe);
components.set('Swiper', Swiper);
components.set('TabGroup', TabGroup);
components.set('Table', Table);
components.set('TextCallOut', TextCallOut);
components.set('ThreeColumnLayout', ThreeColumnLayout);
components.set('ThreeUp', ThreeUp);
components.set('TwoColumn', TwoColumn);
components.set('GET_AUTHOR_ID', GET_AUTHOR_ID);
components.set('GET_BLOG_POSTS', GET_BLOG_POSTS);
components.set('GET_CATEGORIES', GET_CATEGORIES);
components.set('GET_CONTACT_CARDS', GET_CONTACT_CARDS);
components.set('GET_FACULTY_STAFF', GET_FACULTY_STAFF);
components.set('ContentCard', ContentCard);
components.set('PictureContentCard', PictureContentCard);
components.set('ScriptLoader', ScriptLoader);
components.set('SharedContentBlock', SharedContentBlock);
components.set('AlertTypes', AlertTypes);
components.set('ClinicalFocusTypes', ClinicalFocusTypes);
components.set('Department', Department);
components.set('FacultyTypes', FacultyTypes);
components.set('FilterTypes', FilterTypes);
components.set('ListItem', ListItem);
components.set('LocationFunctionTypes', LocationFunctionTypes);
components.set('LocationTypes', LocationTypes);
components.set('MapTypes', MapTypes);
components.set('OSFHeaderTypes', OSFHeaderTypes);
components.set('ProviderTypes', ProviderTypes);
components.set('ScheduleTypes', ScheduleTypes);
components.set('SpecialtyTypes', SpecialtyTypes);

export const componentBuilder = new ComponentBuilder({ components });

export const moduleFactory = componentBuilder.getModuleFactory();
